import styled from 'styled-components';

import Logo from '@assets/images/aboutUs/sfx-logo.svg';
import SFX from '@assets/images/aboutUs/soft-fx.svg'; 

export const LogoImg = styled(Logo)`
`;

export const SFXImg = styled(SFX)`
`;